import * as React from 'react';

const LocaleContext = React.createContext('de');

export const LocaleProvider = LocaleContext.Provider;
export const LocaleConsumer = LocaleContext.Consumer;